import { mutator } from 'satcheljs';
import getStore from '../store/store';
import loadServices from '../actions/loadServices';

/**
 * Loads the current services in the store.
 */
export default mutator(loadServices, actionMessage => {
    let store = getStore();
    store.services = actionMessage.services;
    store.servicesOrder = actionMessage.servicesOrder;
});
